import topTitle from "./topTitle";
import courseColumn from "./courseColumn";
import specialColumn from "./specialColumn";
import examColumn from "./examColumn";

export default [topTitle, courseColumn, specialColumn, examColumn];